$(document).ready(function() {
    var ulElement = $("#aa");
    var secondLiElement = ulElement.find("span:eq(0)");
    var secondLiContent = secondLiElement.text();
    var yj_price = Number(secondLiContent.substring(1));   
    
    var okba = $("#flag").text();
    var okbb = Number(okba);
    
    var cj_price = 0 ;
    var save_price = 0 ;

    if(yj_price>0){ 
      cj_price = (yj_price*0.78).toFixed(2);
      save_price = (yj_price-cj_price).toFixed(2);
      saleCode ="8years";  
    }else{ 
      cj_price =  yj_price.toFixed(2);
      save_price = 0;
      saleCode =" "; 
    }
  

    if(okbb==0){
      var fq_price = (yj_price/4).toFixed(2);
      $("#aa").removeClass("yc_price");
      $("#bb").removeClass("show_price");
      $("#aa").addClass("show_price");
      $("#bb").addClass("yc_price");
    }else{
      var fq_price = (cj_price/4).toFixed(2);
      $("#aa").removeClass("show_price");
      $("#bb").removeClass("yc_price");
      $("#bb").addClass("show_price");
      $("#aa").addClass("yc_price");  
    }
  
    $("#savePrice").text("$"+save_price);
    console.log(cj_price);
    $("#bb").text("$"+cj_price);
    $("#ww").text("$"+cj_price);
    $("#sale_code").text(saleCode);
    $("#price_fq").text("$"+fq_price);
  });